import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/legal",
    name: "legal",
    component: () => import("@/layouts/LegalLayout.vue"),
  },
  {
    name: "account",
    path: "/account",
    component: () => import("@/layouts/SimpleLayout.vue"),
    beforeEnter(to, from, next) {
      if (to.path == "/account/" || to.path == "/account") {
        next({ name: "login" });
      } else {
        next();
      }
    },
    children: [
      {
        name: "register",
        path: "register",
        component: () => import("@/views/Register.vue"),
        props: (route) => {
          return { id: route.query.id };
        },
      },
      {
        name: "login",
        path: "login",
        component: () => import("@/views/Login.vue"),
      },
      {
        name: "recovery",
        path: "recovery",
        component: () => import("@/views/Recovery.vue"),
      },
      {
        name: "wait-confirm",
        path: "wait-confirm",
        component: () => import("@/views/WaitConfirm.vue"),
        // FIXME: добавить beforeEnter с проверкой права wait_person_confirm
      }
    ],
  },
  {
    path: "/cabinet",
    name: "Cabinet",
    component: () => import("@/layouts/CabinetLayout.vue"),
    beforeEnter(to, from, next) {
      if (to.path == "/cabinet/" || to.path == "/cabinet") {
        next({ name: "main" });
      } else {
        next();
      }
    },
    children: [
      {
        name: "main",
        path: "main",
        components: {
          default: () => import("@/views/Cabinet.vue"),
          'append-cabinet': () => import("@/views/CabinetDefaultAppend.vue"),
        },
      },
      {
        name: "billing",
        path: "billing",
        components: {
          default: () => import("@/views/Billing.vue"),
          'append-cabinet': () => import("@/views/CabinetDefaultAppend.vue"),
        },
      },
      {
        name: "team",
        path: "team",
        components: {
          default:() => import("@/views/Team.vue"),
          'append-cabinet': () => import("@/views/CabinetDefaultAppend.vue"),
        },
      },
      {
        name: "meeting",
        path: "meeting",
        components: {
          default:() => import("@/views/MeetingView.vue"),
          'append-cabinet': () => import("@/views/CabinetDefaultAppend.vue"),
        },
      },
      {
        name: "payouts",
        path: "payouts",
        components: {
          default:() => import("@/views/PayoutsView.vue"),
          'append-cabinet': () => import("@/views/CabinetDefaultAppend.vue"),
        },
      },
      {
        name: "promos",
        path: "promos",
        components: {
          default:() => import("@/views/Promos.vue"),
          'append-cabinet': () => import("@/views/CabinetDefaultAppend.vue"),
        },
      },
      {
        name: "apps",
        path: "apps",
        components: {
          default: () => import("@/views/AppView.vue"),
          'append-cabinet': () => import("@/views/CabinetDefaultAppend.vue"),
        },
      },
      {
        name: "bonuses",
        path: "bonuses",
        components: {
          default: () => import("@/views/BonusesView.vue"),
          'append-cabinet': () => import("@/views/CabinetBonusesAppend.vue"),
        },
      },
    ],
  },
  {
    // временно (или не совсем) создаем редирект на внутренние страницы для которых требуется куки с SameSite=Strict
    path: "/redirect/:relativeUrl(.*)*",
    component: () => import("@/layouts/SimpleLayout.vue"),
    beforeEnter(to, from, next) {
      if (!to.params.relativeUrl) {
        next({ name: "Cabinet" });
      } else {
        next();
      }
    },
    children: [
      {
        path: "*",
        component: () => import("@/views/RedirectView.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: { name: "login" },
    // component: () => import("@/views/404.vue"),
    // meta: {
    //   layout: "empty"
    // }
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.query.fromExternal) {
    next({ path: "/redirect" + to.path, query: { ...to.query, fromExternal: undefined }, replace: true });
  } else if (store.getters["profile/waitPersonConfirm"] === true && to.name !== 'wait-confirm') {
    next({ path: "/account/wait-confirm" });
  } else {
    next();
  }
});

export default router;
